var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StatusQuantity',{attrs:{"percentage":_vm.actionPlansData.percentage,"open":_vm.actionPlansData.open,"in-progress":_vm.actionPlansData.in_progress,"completed":_vm.actionPlansData.completed,"others":_vm.actionPlansData.others}})}
var staticRenderFns = []

export { render, staticRenderFns }